import { Tabs, TabsProps } from "antd";
import { t } from "i18next";

import { GoBackButton } from "../../../../components/GoBackButton/GoBackButton";
import style from "./MinistryWarehouseRequestDetails.module.scss";
import { MinistryRequestHistoryTable } from "./components/MinistryRequestHistoryTable/MinistryRequestHistoryTable";
import { MinistryRescriptHistoryTable } from "./components/MinistryRescriptHistoryTable/MinistryRescriptHistoryTable";
import { OverviewWarehoseRequest } from "./components/OverviewWarehoseRequest/OverviewWarehoseRequest";

export const MinistryWarehouseRequestDetails = () => {
  const tabs: TabsProps["items"] = [
    {
      key: "1",
      label: t("SKLADISTA.PREGLED_VAZECEG_ZAHTEVA_SKLADISTA"),
      children: <OverviewWarehoseRequest />,
    },
    {
      key: "2",
      label: t("SKLADISTA.ISTORIJA_ZAHTEVA"),
      children: <MinistryRequestHistoryTable />,
    },
    {
      key: "3",
      label: t("SKLADISTA.ISTORIJA_RESENJA"),
      children: <MinistryRescriptHistoryTable />,
    },
  ];

  const routePath = "/mfin/listaSkladista";
  return (
    <div className={style.mainContainer}>
      <GoBackButton
        routePath={routePath}
        options={{ state: { usePersistedFilters: true } }}
      />
      <Tabs defaultActiveKey="1" items={tabs} />
    </div>
  );
};
